// Custom Fields Types
export interface CustomFieldDefinition {
    id: number;
    name: string;
    displayName: string;
    description: string;
    fieldType: CustomFieldType;
    validationRules: Record<string, any>;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
    selectOptions?: Array<{
        value: string;
        label: string;
    }>;
}

export interface UserCustomFieldValue {
    id: number;
    fieldName: string;
    displayName: string;
    description: string;
    fieldType: string;
    value: string | null;
    formattedValue: string;
    typedValue: any;
    validationRules: Record<string, any> | null;
    selectOptions?: Array<{
        value: string;
        label: string;
    }>;
}

export interface CustomFieldsApiResponse {
    data: UserCustomFieldValue[];
    warnings?: string[];
}

export interface CustomFieldDefinitionsApiResponse {
    data: CustomFieldDefinition[];
}

// Field Types Enum (matching backend)
export enum CustomFieldType {
    NUMBER = 'NUMBER',
    DECIMAL = 'DECIMAL',
    SELECT = 'SELECT',
    TEXT = 'TEXT',
    DATE = 'DATE',
    BOOLEAN = 'BOOLEAN',
}

// Update Custom Fields Request
export interface UpdateUserCustomFieldsRequest {
    values: Array<{
        fieldDefinitionId: number;
        value: string | null;
    }>;
}

// Form Values for Formik
export interface CustomFieldFormValues {
    [fieldDefinitionId: string]: any;
}
